// extracted by mini-css-extract-plugin
export default {"container":"contentWrapper-module--container--y+sr1","content":"contentWrapper-module--content--GeRdn","mainPage":"contentWrapper-module--mainPage--9R0Xs"};